/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Made by Mateusz Janeczek
 **/
import React from 'react';
import s from './DropCheckbox.scss';
import zoom_icon from './zoom_icon.png';
import { connect } from 'react-redux';
import {
  setCurrentMapComposition,
  toggleAdditionals,
  setMapLayerVisibility,
  selectLayer,
  setLayersArea,
} from '../../../actions/layers';
import chevron_down from './double_chevron_right.png';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

const name_map = {
  mpzp: 'Przeznaczenie terenu',
  mpzp_meta: 'Granica planów',
  tereny_sasiadujace: 'Tereny sąsiednich inwestycji',
  siec_wodociagowa: 'Sieć wodociągowa',
  siec_telekomunikacyjna: 'Sieć telekomunikacyjna',
  siec_kanalizacyjna: 'Sieć kanalizacyjna',
  inwestor: 'Tereny pod inwestycje',
  siec_gazowa: 'Sieć gazowa',
  siec_elektroenergetyczna: 'Sieć elektroenergetyczna',
  siec_cieplownicza: 'Sieć ciepłownicza',
  mpzp_dod_info_liniowe: 'Dodatkowe info. liniowe',
  granica_gminy: 'Granica gminy',
  mpzp_dod_info_pow: 'Dodatkowe info. powierzchniowe',
  dzialki_ewidencyjne2: 'Działki ewidencyjne',
  max_wysokosc_lin: 'Linia max. wysokości zabudowy',
  nieprzekraczalne_linie: 'Nieprzekraczalne linie zabudowy',
  granice_uzytkow: 'Granice użytków',
  budynki: 'Budynki',
  warstwice: 'Warstwice',
  cmentarze_groby: 'Groby',
  cmentarze_infrastruktura_punktowa: 'Infrastruktura punktowa',
  cmentarze_infrastruktura_liniowa: 'Infrastruktura liniowa',
  cmentarze_infrastruktura_powierzchniowa: 'Infrastruktura powierzchniowa',
  cmentarze: 'Granica cmentarza',
  cmentarze_sektory: 'Sektory',
};

class DropCheckBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      layersBox: false,
    };
  }
  /**
   * Sets layer visibility
   * setMapLayerVisibility
   */
  selectLayer = layer => this.props.setMapLayerVisibility(layer);

  onClickLayersZoom = index => {
    // this.props.changeCenter([(v.boundingbox.maxy + v.boundingbox.miny) /2,(v.boundingbox.maxx + v.boundingbox.minx) /2]);
    this.props.setLayersArea(index);
  };
  showCheckboxes = () => {
    if (!this.state.expanded) {
      this.setState({ expanded: true });
    } else {
      this.setState({ expanded: false });
    }
  };
  showLayersDrop = () => {
    this.setState({ layersBox: !this.state.layersBox });
  };

  render() {
    const layersBox =
      this.state.layersBox && !this.props.disabled
        ? 'dropdown-content show-drop'
        : 'dropdown-content';
    const dropdown = !this.props.disabled ? 'dropdown' : 'dropdown disabled';
    return (
      <div className={dropdown}>
        <div className="drop-button-div">
          <button disabled={this.props.disabled} onClick={() => this.showLayersDrop()} className="dropbtn">
            <img
              className={!this.state.layersBox ? 'dropdown-img' : 'dropdown-img inverted'}
              src={chevron_down}
            />
          </button>
        </div>
        <div className={layersBox}>
          <hr style={{ marginBottom: '5px', marginTop: '5px' }} />
          {this.props.composition
            ? this.props.currentComposition.layers
                .sort((a, b) => parseInt(b.nr) - parseInt(a.nr))
                .map((v, i) => {
                  const nazwa =
                    Object.keys(name_map).indexOf(v.warstwa) > -1 ? name_map[v.warstwa] : v.warstwa;
                  if (v) {
                    return (
                      <p key={i} className="dropdown-item">
                        <a className="dropdown-layer" id={i} onClick={() => this.selectLayer(v)}>
                          <input className="checkBox" checked={v.isVisible} type="checkbox" />
                          &nbsp;{nazwa}
                        </a>
                        <button
                          disabled={!v.isVisible}
                          onClick={() => this.onClickLayersZoom(i)}
                          className="btn btn-default layer-button"
                          name="zoomButton"
                        >
                          <img className="zoom-img" src={zoom_icon} />
                        </button>
                      </p>
                    );
                  }
                  return (
                    <div key={i}>
                      <label className="listObject">
                        <input
                          onChange={() => this.selectGroup(v)}
                          checked={v.isVisible}
                          type="checkbox"
                          className="form-control"
                          name="checkbox"
                          value={v.warstwa}
                        />
                        <span>&nbsp;&nbsp;{nazwa}</span>
                      </label>
                    </div>
                  );
                })
            : null}
        </div>
      </div>
    );
  }
}

const mapState = state => ({
  district: state.district.district,
  currentComposition: state.layers.currentMapComposition,
});

const mapDispatch = {
  setCurrentMapComposition,
  toggleAdditionals,
  setMapLayerVisibility,
  selectLayer,
  setLayersArea,
};

export default withStyles(s)(
  connect(
    mapState,
    mapDispatch,
  )(DropCheckBox),
);



// WEBPACK FOOTER //
// src/components/Modals/LayersModal/DropCheckbox.js